import React from "react";
import { Box, CircularProgress, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  indicator: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    padding: "4px 10px",
    borderRadius: 999,
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.secondary,
    fontSize: "0.75rem",
    fontWeight: 500,
  },
  spinner: {
    color: "inherit",
  },
  text: {
    fontSize: "0.75rem",
    lineHeight: 1,
  },
}));

const PageRefreshIndicator = ({ visible, label = "Atualizando..." }) => {
  const classes = useStyles();

  if (!visible) {
    return null;
  }

  return (
    <Box className={classes.indicator}>
      <CircularProgress size={12} thickness={6} className={classes.spinner} />
      <Typography component="span" className={classes.text}>
        {label}
      </Typography>
    </Box>
  );
};

export default PageRefreshIndicator;
